import {createEventHandler} from 'recompose';
import fuse from '../../../_libs/redux-fusion';
import {getOrganization} from '../../../app/model/reducers/state';
import {CreateCardContainerHOC} from '../../../components/lists/CreateCard';
import {getId} from '../../../core-utilities/domain/ReduxUtils';
import {createProjectRequest} from '../../redux/createProject';
import {CreateProjectCardComponent} from './CreateProjectCardComponent';


const buildOnSave = (state$, dispatch, props$, actions) => {
  const {
    handler: onSave,
    stream: save$,
  } = createEventHandler();

  const orgId$ = state$
    .map(getOrganization)
    .map(getId)
    .distinctUntilChanged();

  save$
    .withLatestFrom(orgId$)
    .takeUntil(props$.last())
    .subscribe(([data, orgId]) => {
      const request = {
        locationOrientation: 'many',
        ...data,
        isPrivate: !!data.isPrivate,
        orgId,
      };
      dispatch(actions.sendRequest(request));
    });

  return onSave;
};

const StreamedComponent = CreateCardContainerHOC({
  reduxRequest: createProjectRequest,
  buildOnSave,
});

export const CreateProjectCardContainer = fuse(StreamedComponent)(CreateProjectCardComponent);



// WEBPACK FOOTER //
// ./src/js/projects/components/CreateProjectCard/CreateProjectCardContainer.js